import { useContext, useEffect, useState } from 'react';
import '../onboarding-5050-card-overrides.scss';
import { useAnalytics } from '../../../../../../hooks/use-analytics';
import { VideoCategoriesResponse } from '../../../../../../services/onboarding-brightcove-video-service/popular-video-service.types';
import { popularVideos } from '../../../../../../services/onboarding-brightcove-video-service/popular-video-service';

import { FMCardFiftyFifty } from '@own/fds-react';
import { useDyfFdsCardContent } from '../../../../../../views/dyf-landing-view/hooks/use-dyf-fds-cards';
import { useDyfFdsButtonContent } from '../../../../../../views/dyf-landing-view/hooks/use-dyf-fds-buttons';
import { addModelToCard } from '../../trio-cards';
import { useAemImageRendition } from '../../../../../../hooks/use-aem-image-rendition/use-aem-image-rendition';
import { EligibleModelData } from '../../../../../../hooks/dyf/use-dyf-eligible-model/use-dyf-eligible-model';
import ServerContext from '../../../../../../contexts/serverContext';
import { useFeatureGuideContent } from '../../../../../../views/dyf-landing-view/hooks/use-dyf-feature-guide-content';

interface HtvFiftyFiftyProps {
    baseRoot: string;
    eligibleModelData: EligibleModelData;
    discoverYourFordText: string;
    isMobile?: boolean;
}
export const DyfHtv5050 = ({
    baseRoot,
    eligibleModelData,
    discoverYourFordText,
    isMobile,
}: HtvFiftyFiftyProps) => {
    const [fireEvents] = useAnalytics();
    const { currentLanguageRegionCode } = useContext(ServerContext);
    const [shouldHide, setShouldHide] = useState(false);

    const featureGuideContent = useFeatureGuideContent();
    const dyfLandingHtvCard = useDyfFdsCardContent('htv');
    const dyfLandingHtvCardButton = useDyfFdsButtonContent('htv');

    const optimizedImage = useAemImageRendition({
        src:
            dyfLandingHtvCard?.mediaSrc ??
            featureGuideContent?.howToVideos5050Image,
        renditionsMap: 'default',
        removeDomain: false,
    });

    const getHasVideos = async (): Promise<boolean> => {
        let categoryVideos: VideoCategoriesResponse = {};
        categoryVideos = await popularVideos.getVideosByCategories(
            eligibleModelData?.modelYear,
            eligibleModelData.modelMake,
            eligibleModelData.modelDisplayName,
            currentLanguageRegionCode
        );
        return (
            JSON.stringify(categoryVideos) !== '{}' &&
            Object.keys(categoryVideos).length > 0
        );
    };

    useEffect(() => {
        if (eligibleModelData.hideHTV) {
            return setShouldHide(true);
        } else {
            getHasVideos().then(res => setShouldHide(!res));
        }
    }, [currentLanguageRegionCode, eligibleModelData]);

    return (
        <div className="dyf-htv-5050--wrap" data-testid="htv-5050">
            {shouldHide ? (
                <></>
            ) : (
                <FMCardFiftyFifty
                    title={discoverYourFordText}
                    headline={
                        dyfLandingHtvCard.title ??
                        featureGuideContent?.howToVideos5050Title
                    }
                    description={addModelToCard(
                        dyfLandingHtvCard.body ??
                            featureGuideContent?.howToVideos5050Body ??
                            '',
                        eligibleModelData.modelDisplayName
                    )}
                    media={{
                        src: isMobile ? '' : optimizedImage,
                        alt:
                            dyfLandingHtvCard.mediaAltText ??
                            featureGuideContent?.howToVideos5050ImageAltText ??
                            '',
                    }}
                    button={{
                        type: 'primary',
                        label:
                            dyfLandingHtvCardButton.buttonLabel ??
                            featureGuideContent?.howToVideos5050ButtonLabel,
                        href: `${baseRoot}/vehicle/${
                            eligibleModelData?.modelAlias
                        }/${
                            eligibleModelData!.modelYear
                        }/how-to-videos/video-library/`,
                        disabled: false,
                        onClick: () =>
                            fireEvents('dyf-cards-onclick', undefined, {
                                dyfComponentName:
                                    dyfLandingHtvCard.title ??
                                    featureGuideContent?.howToVideos5050Title,
                                categoryName:
                                    dyfLandingHtvCardButton.buttonLabel ??
                                    featureGuideContent?.howToVideos5050ButtonLabel,
                            }),
                    }}
                    mediaSide={'right'}
                />
            )}
        </div>
    );
};
